import styled from "styled-components";

export const TextButtonStyled = styled.button<{
  size: "small" | "medium" | "large";
  color: "primary" | "secondary" | "danger";
  underline: boolean;
}>`
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 500;
  transition: all 0.2s ease;
  text-decoration: ${(props) => (props.underline ? "underline" : "none")};

  /* Size variants */
  ${(props) => {
    switch (props.size) {
      case "small":
        return `
          font-size: 12px;
          padding: 4px 8px;
        `;
      case "large":
        return `
          font-size: 16px;
          padding: 8px 12px;
        `;
      default:
        return `
          font-size: 14px;
          padding: 6px 10px;
        `;
    }
  }}

  /* Color variants */
  ${(props) => {
    switch (props.color) {
      case "primary":
        return `
          color: #2196f3;
          
          &:hover:not(:disabled) {
            color: #1976d2;
            text-decoration: underline;
          }
        `;
      case "secondary":
        return `
          color: #666;
          
          &:hover:not(:disabled) {
            color: #333;
            text-decoration: underline;
          }
        `;
      case "danger":
        return `
          color: #f44336;
          
          &:hover:not(:disabled) {
            color: #d32f2f;
            text-decoration: underline;
          }
        `;
      default:
        return "";
    }
  }}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
